// src/pages/SafariZoneNorth.jsx
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";
import SafariZoneTimer from '../../components/SafariZoneTimer';
import withSafariZoneProtection from '../../components/SafariZoneProtection';

const SafariZoneNorth = () => {
  return (
    <>
      <GameMap config={mapConfigs.safariZoneNorth} />
      <SafariZoneTimer />
    </>
  );
};

export default withSafariZoneProtection(SafariZoneNorth);
